// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-screen-container {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: radial-gradient(circle at top, rgba(191, 233, 236, 0.2), transparent 60%), var(--jedi-background);
  font-family: 'Arial', sans-serif;
}

.login-screen-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
}

.login-screen-card {
  position: relative;
  width: min(480px, 92vw);
  background: rgba(22, 22, 22, 0.95);
  border: 1px solid rgba(196, 222, 29, 0.35);
  border-radius: 18px;
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.4);
  overflow: hidden;
}

.login-screen-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 30px 24px 16px;
  color: #ffffff;
  text-align: center;
}

.login-screen-logo-wrapper {
  width: 110px;
  height: 110px;
  border-radius: 999px;
  background: rgba(196, 222, 29, 0.15);
  border: 1px solid rgba(196, 222, 29, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-screen-logo {
  width: 88px;
  height: 88px;
  object-fit: contain;
}

.login-screen-header h1 {
  margin: 0;
  font-size: 1.7rem;
  color: var(--jedi-main-title);
}

.login-screen-header p {
  margin: 0;
  opacity: 0.86;
}

.login-screen-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 24px 24px;
}

.login-screen-form label {
  font-size: 0.92rem;
  color: #d6e0e8;
}

.login-screen-form input {
  width: 100%;
  border: 1px solid rgba(196, 222, 29, 0.28);
  background: #111;
  color: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  outline: none;
}

.login-screen-form input:focus {
  border-color: var(--jedi-green);
  box-shadow: 0 0 0 2px rgba(196, 222, 29, 0.18);
}

.login-screen-password-wrapper {
  position: relative;
  flex: 1 1;
}

.login-screen-password-wrapper input {
  padding-right: 88px;
}

.login-screen-password-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.login-screen-password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  color: #9eb2c6;
  font-weight: 600;
  cursor: pointer;
}

.login-screen-trocar-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #f3f4f6;
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.login-screen-trocar-label input[type='checkbox'] {
  width: 18px;
  height: 18px;
  accent-color: var(--jedi-green);
  cursor: pointer;
}

.login-screen-error {
  background: rgba(255, 95, 95, 0.16);
  border: 1px solid rgba(255, 95, 95, 0.4);
  color: #ffd7d7;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.9rem;
}

.login-screen-success {
  background: rgba(196, 222, 29, 0.18);
  border: 1px solid rgba(196, 222, 29, 0.45);
  color: #eef7b9;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 0.9rem;
}

.login-screen-submit {
  margin-top: 8px;
  border: none;
  border-radius: 12px;
  padding: 14px 16px;
  background: var(--jedi-green);
  color: #20240a;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
}

.login-screen-submit:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.login-screen-footer {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 0.9rem;
  color: #d6e0e8;
}

.login-screen-link {
  border: none;
  background: transparent;
  color: var(--jedi-green);
  font-weight: 700;
  opacity: 0.95;
  cursor: pointer;
}

@media screen and (max-width: 520px) {
  .login-screen-password-row {
    align-items: stretch;
    flex-direction: column;
  }

  .login-screen-trocar-label {
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginScreen.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,6GAA6G;EAC7G,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,oCAAoC;EACpC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".login-screen-container {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 10000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n  background: radial-gradient(circle at top, rgba(191, 233, 236, 0.2), transparent 60%), var(--jedi-background);\r\n  font-family: 'Arial', sans-serif;\r\n}\r\n\r\n.login-screen-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n.login-screen-card {\r\n  position: relative;\r\n  width: min(480px, 92vw);\r\n  background: rgba(22, 22, 22, 0.95);\r\n  border: 1px solid rgba(196, 222, 29, 0.35);\r\n  border-radius: 18px;\r\n  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.4);\r\n  overflow: hidden;\r\n}\r\n\r\n.login-screen-header {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 30px 24px 16px;\r\n  color: #ffffff;\r\n  text-align: center;\r\n}\r\n\r\n.login-screen-logo-wrapper {\r\n  width: 110px;\r\n  height: 110px;\r\n  border-radius: 999px;\r\n  background: rgba(196, 222, 29, 0.15);\r\n  border: 1px solid rgba(196, 222, 29, 0.4);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.login-screen-logo {\r\n  width: 88px;\r\n  height: 88px;\r\n  object-fit: contain;\r\n}\r\n\r\n.login-screen-header h1 {\r\n  margin: 0;\r\n  font-size: 1.7rem;\r\n  color: var(--jedi-main-title);\r\n}\r\n\r\n.login-screen-header p {\r\n  margin: 0;\r\n  opacity: 0.86;\r\n}\r\n\r\n.login-screen-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: 10px 24px 24px;\r\n}\r\n\r\n.login-screen-form label {\r\n  font-size: 0.92rem;\r\n  color: #d6e0e8;\r\n}\r\n\r\n.login-screen-form input {\r\n  width: 100%;\r\n  border: 1px solid rgba(196, 222, 29, 0.28);\r\n  background: #111;\r\n  color: #fff;\r\n  border-radius: 12px;\r\n  padding: 12px 14px;\r\n  outline: none;\r\n}\r\n\r\n.login-screen-form input:focus {\r\n  border-color: var(--jedi-green);\r\n  box-shadow: 0 0 0 2px rgba(196, 222, 29, 0.18);\r\n}\r\n\r\n.login-screen-password-wrapper {\r\n  position: relative;\r\n  flex: 1;\r\n}\r\n\r\n.login-screen-password-wrapper input {\r\n  padding-right: 88px;\r\n}\r\n\r\n.login-screen-password-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.login-screen-password-toggle {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  border: none;\r\n  background: transparent;\r\n  color: #9eb2c6;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.login-screen-trocar-label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #f3f4f6;\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n\r\n.login-screen-trocar-label input[type='checkbox'] {\r\n  width: 18px;\r\n  height: 18px;\r\n  accent-color: var(--jedi-green);\r\n  cursor: pointer;\r\n}\r\n\r\n.login-screen-error {\r\n  background: rgba(255, 95, 95, 0.16);\r\n  border: 1px solid rgba(255, 95, 95, 0.4);\r\n  color: #ffd7d7;\r\n  border-radius: 10px;\r\n  padding: 10px 12px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.login-screen-success {\r\n  background: rgba(196, 222, 29, 0.18);\r\n  border: 1px solid rgba(196, 222, 29, 0.45);\r\n  color: #eef7b9;\r\n  border-radius: 10px;\r\n  padding: 10px 12px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.login-screen-submit {\r\n  margin-top: 8px;\r\n  border: none;\r\n  border-radius: 12px;\r\n  padding: 14px 16px;\r\n  background: var(--jedi-green);\r\n  color: #20240a;\r\n  font-weight: 700;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.login-screen-submit:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.login-screen-footer {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  font-size: 0.9rem;\r\n  color: #d6e0e8;\r\n}\r\n\r\n.login-screen-link {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--jedi-green);\r\n  font-weight: 700;\r\n  opacity: 0.95;\r\n  cursor: pointer;\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .login-screen-password-row {\r\n    align-items: stretch;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .login-screen-trocar-label {\r\n    justify-content: flex-end;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
